module.exports = {
  env: process.env.VUE_APP_ENV,
  language: process.env.VUE_APP_LANGUAGE,
  country: process.env.VUE_APP_COUNTRY,
  apiURL: process.env.VUE_APP_API_URL,
  gtagID: process.env.VUE_APP_GTAGID,
  stripePublic: process.env.VUE_APP_STRIPEPUBLIC
}
